// extracted by mini-css-extract-plugin
export var carrierIcon = "_xi-0";
export var carrierLogo = "_xi-1";
export var detailsSection = "_xi-2";